import React from 'react';
import { NavLink } from 'react-router-dom';

const secondaryNavigation = [
  { name: 'Karten', href: '/dashboard/kartenverwaltung/karten' },
  { name: 'Entwürfe', href: '/dashboard/kartenverwaltung/entwuerfe' },
];

const KartenNavigation = () => {
  return (
    <header className="border-b border-white/5">
      {/* Secondary navigation */}
      <nav className="flex overflow-x-auto py-4">
        <ul
          role="list"
          className="flex min-w-full flex-none gap-x-6 px-4 text-sm font-semibold leading-6 text-gray-700 sm:px-6 lg:px-8"
        >
          {secondaryNavigation.map((item) => (
            <li key={item.name}>
              <NavLink to={item.href}>
                {({ isActive }) => (
                  <span className={isActive ? 'text-svisit-primary-400' : ''}>
                    {item.name}
                  </span>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default KartenNavigation;
